import React, { useState } from 'react';
import { Smartphone, Glasses, Check, AlertCircle, Wifi, Bluetooth, RefreshCw } from 'lucide-react';
export const VRDeviceSetup = () => {
  const [scanning, setScanning] = useState(false);
  const [deviceFound, setDeviceFound] = useState(false);
  const handleScan = () => {
    setScanning(true);
    setTimeout(() => {
      setScanning(false);
      setDeviceFound(true);
    }, 2000);
  };
  return <div className="space-y-6" data-id="element-22567">
      <div data-id="element-22568">
        <h3 className="text-lg font-medium mb-2" data-id="element-22569">Compatible Devices</h3>
        <p className="text-sm text-gray-400 mb-4" data-id="element-22570">
          SinShift AI works with these VR and AR devices for the best immersive
          experience
        </p>
        <div className="grid grid-cols-2 gap-4" data-id="element-22571">
          <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22572">
            <div className="flex items-center gap-2 mb-2" data-id="element-22573">
              <Glasses size={18} className="text-pink-400" data-id="element-22574" />
              <h4 className="font-medium" data-id="element-22575">VR Headsets</h4>
            </div>
            <ul className="text-sm space-y-2" data-id="element-22576">
              <li className="flex items-center gap-2" data-id="element-22577">
                <Check size={12} className="text-green-400" data-id="element-22578" />
                <span data-id="element-22579">Meta Quest 2 & 3</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-22580">
                <Check size={12} className="text-green-400" data-id="element-22581" />
                <span data-id="element-22582">HTC Vive Pro</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-22583">
                <Check size={12} className="text-green-400" data-id="element-22584" />
                <span data-id="element-22585">Valve Index</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-22586">
                <Check size={12} className="text-green-400" data-id="element-22587" />
                <span data-id="element-22588">PlayStation VR2</span>
              </li>
            </ul>
          </div>
          <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22589">
            <div className="flex items-center gap-2 mb-2" data-id="element-22590">
              <Smartphone size={18} className="text-pink-400" data-id="element-22591" />
              <h4 className="font-medium" data-id="element-22592">AR Devices</h4>
            </div>
            <ul className="text-sm space-y-2" data-id="element-22593">
              <li className="flex items-center gap-2" data-id="element-22594">
                <Check size={12} className="text-green-400" data-id="element-22595" />
                <span data-id="element-22596">iPhone 12+ with LiDAR</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-22597">
                <Check size={12} className="text-green-400" data-id="element-22598" />
                <span data-id="element-22599">Samsung Galaxy S22+</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-22600">
                <Check size={12} className="text-green-400" data-id="element-22601" />
                <span data-id="element-22602">Google Pixel 6+</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-22603">
                <Check size={12} className="text-green-400" data-id="element-22604" />
                <span data-id="element-22605">iPad Pro with LiDAR</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-gray-800 rounded-lg p-4 border border-gray-700" data-id="element-22606">
        <h3 className="text-lg font-medium mb-2" data-id="element-22607">Device Detection</h3>
        <p className="text-sm text-gray-400 mb-4" data-id="element-22608">
          Let's find your VR/AR devices to get started with immersive
          experiences
        </p>
        <div className="space-y-4" data-id="element-22609">
          {deviceFound ? <div className="p-3 bg-green-900/20 border border-green-800/30 rounded-lg" data-id="element-22610">
              <div className="flex items-center gap-2" data-id="element-22611">
                <div className="w-8 h-8 flex items-center justify-center bg-green-500/20 rounded-full text-green-400" data-id="element-22612">
                  <Check size={16} data-id="element-22613" />
                </div>
                <div data-id="element-22614">
                  <h4 className="font-medium" data-id="element-22615">Meta Quest 3 Detected</h4>
                  <p className="text-xs text-gray-400" data-id="element-22616">
                    Connected via Bluetooth
                  </p>
                </div>
                <button className="ml-auto text-xs px-3 py-1 bg-green-500/20 rounded-full text-green-400" data-id="element-22617">
                  Connected
                </button>
              </div>
            </div> : <div className="p-3 bg-gray-900/50 border border-gray-700 rounded-lg" data-id="element-22618">
              <div className="flex items-center gap-2" data-id="element-22619">
                <div className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full text-gray-400" data-id="element-22620">
                  <Glasses size={16} data-id="element-22621" />
                </div>
                <div data-id="element-22622">
                  <h4 className="font-medium" data-id="element-22623">No VR Headset Detected</h4>
                  <p className="text-xs text-gray-400" data-id="element-22624">
                    Make sure your device is turned on and nearby
                  </p>
                </div>
                <button className={`ml-auto text-xs px-3 py-1 rounded-full ${scanning ? 'bg-pink-500/20 text-pink-400' : 'bg-gray-700 text-gray-300'}`} onClick={handleScan} disabled={scanning} data-id="element-22625">
                  {scanning ? <span className="flex items-center gap-1" data-id="element-22626">
                      <RefreshCw size={12} className="animate-spin" data-id="element-22627" />
                      Scanning...
                    </span> : 'Scan for Devices'}
                </button>
              </div>
            </div>}
          <div className="grid grid-cols-2 gap-3" data-id="element-22628">
            <div className="flex items-center gap-2 p-3 bg-gray-900/50 border border-gray-700 rounded-lg" data-id="element-22629">
              <Bluetooth size={16} className="text-blue-400" data-id="element-22630" />
              <span className="text-sm" data-id="element-22631">Bluetooth</span>
              <div className="ml-auto w-8 h-4 bg-blue-900/30 rounded-full relative" data-id="element-22632">
                <div className="absolute inset-0 m-0.5 bg-blue-500 rounded-full left-0 right-1/2" data-id="element-22633"></div>
              </div>
            </div>
            <div className="flex items-center gap-2 p-3 bg-gray-900/50 border border-gray-700 rounded-lg" data-id="element-22634">
              <Wifi size={16} className="text-green-400" data-id="element-22635" />
              <span className="text-sm" data-id="element-22636">Wi-Fi</span>
              <div className="ml-auto w-8 h-4 bg-green-900/30 rounded-full relative" data-id="element-22637">
                <div className="absolute inset-0 m-0.5 bg-green-500 rounded-full" data-id="element-22638"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-3" data-id="element-22639">
        <h3 className="text-lg font-medium" data-id="element-22640">Setup Instructions</h3>
        <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22641">
          <div className="flex items-center gap-2 mb-2" data-id="element-22642">
            <div className="w-6 h-6 flex items-center justify-center rounded-full bg-pink-500/20 text-pink-400" data-id="element-22643">
              1
            </div>
            <h4 className="font-medium" data-id="element-22644">Turn on your device</h4>
          </div>
          <p className="text-sm text-gray-400 ml-8" data-id="element-22645">
            Make sure your VR headset or AR-capable phone is powered on and has
            sufficient battery
          </p>
        </div>
        <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22646">
          <div className="flex items-center gap-2 mb-2" data-id="element-22647">
            <div className="w-6 h-6 flex items-center justify-center rounded-full bg-pink-500/20 text-pink-400" data-id="element-22648">
              2
            </div>
            <h4 className="font-medium" data-id="element-22649">Enable Bluetooth pairing</h4>
          </div>
          <p className="text-sm text-gray-400 ml-8" data-id="element-22650">
            Put your device in pairing mode and ensure Bluetooth is enabled on
            your phone
          </p>
        </div>
        <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22651">
          <div className="flex items-center gap-2 mb-2" data-id="element-22652">
            <div className="w-6 h-6 flex items-center justify-center rounded-full bg-pink-500/20 text-pink-400" data-id="element-22653">
              3
            </div>
            <h4 className="font-medium" data-id="element-22654">Install SinShift VR/AR app</h4>
          </div>
          <p className="text-sm text-gray-400 ml-8 mb-2" data-id="element-22655">
            Download and install the companion app on your VR headset or AR
            device
          </p>
          <div className="ml-8 flex gap-2" data-id="element-22656">
            <button className="px-3 py-1.5 bg-gray-700 rounded-lg text-xs" data-id="element-22657">
              Meta Quest Store
            </button>
            <button className="px-3 py-1.5 bg-gray-700 rounded-lg text-xs" data-id="element-22658">
              SteamVR
            </button>
            <button className="px-3 py-1.5 bg-gray-700 rounded-lg text-xs" data-id="element-22659">
              App Store
            </button>
          </div>
        </div>
        <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22660">
          <div className="flex items-center gap-2 mb-2" data-id="element-22661">
            <div className="w-6 h-6 flex items-center justify-center rounded-full bg-pink-500/20 text-pink-400" data-id="element-22662">
              4
            </div>
            <h4 className="font-medium" data-id="element-22663">Connect and enjoy</h4>
          </div>
          <p className="text-sm text-gray-400 ml-8" data-id="element-22664">
            Once connected, you'll be able to access all VR/AR experiences with
            your AI companion
          </p>
        </div>
        <div className="p-3 bg-pink-900/20 border border-pink-800/30 rounded-lg" data-id="element-22665">
          <div className="flex items-center gap-2" data-id="element-22666">
            <AlertCircle size={16} className="text-pink-400" data-id="element-22667" />
            <p className="text-sm" data-id="element-22668">
              Need help? Our 24/7 support team can assist with device setup
            </p>
            <button className="ml-auto text-xs px-3 py-1 bg-pink-500/20 rounded-full text-pink-400" data-id="element-22669">
              Contact Support
            </button>
          </div>
        </div>
      </div>
    </div>;
};